var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    staticClass: "payment-connect",
    attrs: {
      title: "".concat(_vm.isEdit ? "修改发票信息" : "确认开票"),
      width: "400px",
      visible: _vm.visible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      close: _vm.cancel
    }
  }, [_c("div", [_vm.title ? _c("div", {
    staticClass: "popover-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c("div", {
    staticClass: "popover-content"
  }, [_c("el-form", {
    ref: "ruleForm",
    staticClass: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "金额",
      prop: "receiptAmount"
    }
  }, [_c("span", [_vm._v(" ¥ " + _vm._s(_vm.formatThousands(_vm.form.receiptAmount)))])]), _c("el-form-item", {
    attrs: {
      label: "打款方",
      prop: "payer"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payer))])]), _c("el-form-item", {
    attrs: {
      label: "收款方",
      prop: "payeeCompany"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payeeCompany))]), _c("SourceTag", {
    attrs: {
      type: _vm.form.dataSource
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "开票类型"
    }
  }, [_vm.form.invoiceType == "0" ? _c("div", [_vm._v("普票")]) : _vm._e(), _vm.form.invoiceType == "1" ? _c("div", [_vm._v("专票")]) : _vm._e()]), _c("el-form-item", {
    attrs: {
      label: "开票公司"
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.form.invoicingCompany))])]), _c("el-form-item", {
    attrs: {
      label: "开票税号"
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.form.invoicingTaxNumber))])]), _c("el-form-item", {
    attrs: {
      label: "上传发票",
      prop: "slip"
    }
  }, [_c("UploadFile", {
    attrs: {
      accept: ".pdf"
    },
    model: {
      value: _vm.form.slip,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "slip", $$v);
      },
      expression: "form.slip"
    }
  })], 1)], 1)], 1)]), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };